import React from "react";
import { Quote } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const Testimonials = () => {
  const { t } = useLang();
  return (
    <section
      data-testid="testimonials-section"
      className="py-24 sm:py-32 bg-[#1A1F24] text-[#F9F6F0]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="max-w-3xl mb-16">
          <p className="text-[#C6A87C] text-xs uppercase tracking-[0.3em] mb-4">
            {t.testimonials.eyebrow}
          </p>
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight">
            {t.testimonials.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {t.testimonials.items.map((tm) => (
            <div
              key={tm.author}
              data-testid={`testimonial-${tm.author}`}
              className="bg-[#252A30] border border-white/5 p-8 sm:p-10 relative"
            >
              <Quote className="w-8 h-8 text-[#C6A87C] mb-6" strokeWidth={1} />
              <p className="text-[#E2E8F0] leading-relaxed italic font-serif text-lg mb-8">
                &ldquo;{tm.quote}&rdquo;
              </p>
              <div className="border-t border-white/10 pt-6">
                <p className="text-sm font-semibold tracking-wide">{tm.author}</p>
                <p className="text-xs text-[#A0AEC0] uppercase tracking-[0.2em] mt-1">
                  {tm.origin}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
